export class PropostaObservacao {
  public id!: number;
  public dtInclusao!: Date;
  public proposta!: number;
  public observacao!: string;
  public obsBanco!: boolean;
  public idUsuario!: number;
  public usuario!: string;
}